import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
];

const pascalNames: Array<string> = [
  "Projects",
  "Vsrgs",
  "Programming",
  "Art",
  "About",
  "Contact",
  "Release",
  "Cv",
  "Test",
];
for (const pascal of pascalNames) {
  const kebab: string = pascal
    .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
      return "-" + y.toLowerCase();
    })
    .replace(/^-/, "");
  routes.push({
    path: "/" + kebab.toString(),
    name: pascal,
    component: () => import("@/views/" + pascal + ".vue"),
  });
}
export default routes;
